import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import * as Icon from "react-feather";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

export default function Navbar() {
  const [isToggled, setIsToggled] = useState(false);
  const [isSidebarFolded, setIsSidebarFolded] = useState(false);

  const role = localStorage.getItem("role"); // your role

  const handleToggle = () => {
    setIsToggled(!isToggled);
    document.body.classList.toggle("sidebar-folded");
  };

  useEffect(() => {
    const body = document.body;
    const sidebarFolded = "sidebar-folded";
    setIsSidebarFolded(body.classList.contains(sidebarFolded));
  }, []);

  const handleMouseEnter = () => {
    document.body.classList.add("open-sidebar-folded", "overflow-hidden");
  };

  const handleMouseLeave = () => {
    document.body.classList.remove("open-sidebar-folded", "overflow-hidden");
  };

  return (
    <div>
      <nav className="sidebar">
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            Naati<span>CCL</span>
          </a>

          <div
            id="sidebar_t"
            className={isSidebarFolded ? "sidebar-toggler active" : "sidebar-toggler not-active"}
            onClick={handleToggle}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <PerfectScrollbar component="div">
          <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="sidebar-body">
            <ul className="nav">

              {/* Dashboard */}
              <li className="nav-item">
                <NavLink to="/dashboard" className="nav-link newNav" activeClassName="active">
                  <Icon.Home className="link-icon" />
                  <span className="link-title">Dashboard</span>
                </NavLink>
              </li>

              {/* Word List */}
              {role !== "2" && (
                <li className="nav-item">
                  <NavLink to="/words" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">Word List</span>
                  </NavLink>
                </li>
              )}

              {/* Manage Users */}
              {role !== "2" && (
                <li className="nav-item">
                  <a className="nav-link newNav" data-bs-toggle="collapse" href="#naatiuser">
                    <Icon.List className="link-icon" />
                    <span className="link-title">NAATI Manage Users</span>
                    <Icon.ChevronDown className="link-arrow" />
                  </a>

                  <div className="collapse" id="naatiuser">
                    <ul className="nav sub-menu">
                      <li className="nav-item">
                        <NavLink to="/users" className="nav-link newNav" activeClassName="active">
                          <Icon.Users className="link-icon" />
                          <span className="link-title">Users</span>
                        </NavLink>
                      </li>

                      <li className="nav-item">
                        <NavLink to="/add-users" className="nav-link newNav" activeClassName="active">
                          <Icon.Users className="link-icon" />
                          <span className="link-title">Add User</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              )}

              {/* Question Dialogues */}
              <li className="nav-item">
                <a className="nav-link newNav" data-bs-toggle="collapse" href="#question" aria-expanded="false">
                  <Icon.List className="link-icon" />
                  <span className="link-title">Question Dialogues</span>
                  <Icon.ChevronDown className="link-arrow" />
                </a>

                <div className="collapse" id="question">
                  <ul className="nav sub-menu">

                    {/* Show for all roles */}
                    <li className="nav-item">
                      <NavLink to="/questions" className="nav-link newNav" activeClassName="active">
                        <span className="link-title">Question List</span>
                      </NavLink>
                    </li>

                    {/* HIDE FOR ROLE 6 */}
                    {role !== "6" && (
                      <>
                        <li className="nav-item">
                          <NavLink to="/add-question" className="nav-link newNav" activeClassName="active">
                            <span className="link-title">Add Question</span>
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          <NavLink to="/add-questions" className="nav-link newNav" activeClassName="active">
                            <span className="link-title">Add Bulk Questions</span>
                          </NavLink>
                        </li>

                        <li className="nav-item">
                          <NavLink to="/add-audio/file" className="nav-link newNav" activeClassName="active">
                            <span className="link-title">Add Bulk Audio File</span>
                          </NavLink>
                        </li>
                      </>
                    )}

                  </ul>
                </div>
              </li>

              {/* Mock Test */}
              {role !== "2" && (
                <li className="nav-item">
                  <NavLink to="/mock-test/list" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">Manage Mock Test</span>
                  </NavLink>
                </li>
              )}

              <li className="nav-item">
                <NavLink to="/mock-test/analysis" className="nav-link newNav" activeClassName="active">
                  <Icon.List className="link-icon" />
                  <span className="link-title">Mock Test Analysis</span>
                </NavLink>
              </li>

              {/* HIDE FOR ROLE 6 → Manage Plan */}
              {(role !== "6" && role !== "2") && (
                <li className="nav-item">
                  <NavLink to="/plan" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">Manage Plan</span>
                  </NavLink>
                </li>
              )}

              {/* Manage User Access */}
              {role !== "2" && (
                <li className="nav-item">
                  <NavLink to="/manage-user/access" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">Manage Users Access</span>
                  </NavLink>
                </li>
              )}

              {/* HIDE FOR ROLE 6 → User Comments */}
              {(role !== "6" && role !== '2') && (
                <li className="nav-item">
                  <NavLink to="/user-comments" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">User Comments</span>
                  </NavLink>
                </li>
              )}

              {/* HIDE FOR ROLE 6 → Manage Video */}
              {(role !== "6" && role !== '2') && (
                <li className="nav-item">
                  <NavLink to="/video" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">Manage Video</span>
                  </NavLink>
                </li>
              )}

              {/* HIDE FOR ROLE 6 → Online Class Enquiry */}
              {(role !== "6" && role !== '2') && (
                <li className="nav-item">
                  <NavLink to="/enquire-list" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">Online Class Enquire</span>
                  </NavLink>
                </li>
              )}

              {/* HIDE FOR ROLE 6 → Online Class Enquiry */}
              {(role !== "6" && role !== '2') && (
                <li className="nav-item">
                  <NavLink to="/zoom-meetings" className="nav-link newNav" activeClassName="active">
                    <Icon.List className="link-icon" />
                    <span className="link-title">Zoom Meetings</span>
                  </NavLink>
                </li>
              )}

            </ul>
          </div>
        </PerfectScrollbar>
      </nav>
    </div>
  );
}
